import { COLUMN } from '@pages/Filing/ConversionTool/MappingSteps/CTStepOne/constants';

/**
 * Filters mapping columns
 * @param selectedValues
 * @returns {*[]}
 */
export const conversionToolMappingColumnsModel = (selectedValues = {}) =>
  Object.values(selectedValues).filter(item => item.value === COLUMN) || [];
